import { axiosInstance } from '../Middleware'
import { LoginApiResponse } from './types'
import dayjs from 'dayjs'

export class LoginApi {
  public static loadLogin = (tenantId: number, componentId: number, email: string): Promise<LoginApiResponse> =>
    axiosInstance.get('/personnel/personnel/agents/login', {
      headers: {
        'x-tenant': tenantId,
        'x-component': componentId,
      },
      params: {
        login: email,
        dateReference: dayjs().format('YYYY-MM-DD'),
      },
    })
      .then(response => response.data) 

  public static logout = (tenantId: number, componentId: number, tokenId: string): Promise<void> =>
    axiosInstance.get(`/oauth/logout/${tokenId}`, {
      headers: {
        'X-Tenant': tenantId,
        'X-Component': componentId,
        'Authorization': `Bearer ${tokenId}`,
      },
    })
      .then(() => { })
}
